import { Component, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { SimulationSetService } from '@services/simulation-set/simulation-set.service';
import { ResultsetItem } from '@models/resultset-item';
import { Scenario } from '@models/scenario';
import { SettingsService } from '@services/settings/settings.service';
import { SimulationSetValidationError, SimulationSetValidationErrorType } from '@interfaces/simulation-set-errors';

@Component({
  selector: 'app-stress-details',
  templateUrl: './stress-details.component.html',
  styleUrls: ['./stress-details.component.scss']
})
export class StressDetailsComponent implements AfterViewInit {
  @Input() stressGroup: ResultsetItem;
  @Input() parent: ResultsetItem;
  @Input() index: number;
  @Input() parentid: number;
  public changeDatasetVisible = false;
  public get datasets$() {
    return this.simService.datasetArray$;
  }

  public get baselines$() {
    return this.simService.baselineList$;
  }

  public get stresses$() {
    return this.simService.stressList$;
  }

  public get validMnemonic(): boolean {
    const invalid = new Set([
      SimulationSetValidationErrorType.DuplicateMnemonic,
      SimulationSetValidationErrorType.InvalidMnemonic,
      SimulationSetValidationErrorType.MnemonicAlreadyInDB
    ]);
    return !this.validationInfo || !invalid.has(this.validationInfo.type);
  }

  public get validDataset(): boolean {
    return !this.validationInfo || this.validationInfo.type !== SimulationSetValidationErrorType.MissingDataset;
  }

  public get isDeletedDataset(): boolean {
    return this.validationInfo.type !== SimulationSetValidationErrorType.MissingDataset;
  }

  public get validationInfo(): SimulationSetValidationError {
    return this.stressGroup.ValidationError;
  }

  constructor(
    private simService: SimulationSetService,
    private settingsService: SettingsService,
    private cd: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  public getScenarioColor() {
    return this.settingsService.getScenarioColor(this.stressGroup);
  }

  public removeStress() {
    this.simService.removeStressFromState(this.stressGroup.id);
  }

  public changeDatasetToggle() {
    this.changeDatasetVisible = !this.changeDatasetVisible;
  }

  public onChange() {
    this.simService.validateSimulationSet();
  }

  public onScenarioSelect = event => {
    const selectElementValue = Number(event.target.value);
    const scenarioDetails: Scenario = this.simService.stressList.get(selectElementValue);
    const mayexist = this.simService.findResultsetItemInDB(
      this.parent.Scenario_ID,
      this.parent.DataSetID,
      scenarioDetails.scenario_id,
      this.stressGroup.DataSetID
    );

    this.stressGroup.RunID = this.simService.getNewUUID();
    if (mayexist) {
      this.stressGroup.Mnemonic = mayexist.Mnemonic;
      this.stressGroup.Description = mayexist.Description;
      if (mayexist.RunID) {
        this.stressGroup.RunID = mayexist.RunID;
      }
      if (mayexist.ResultSetID) {
        this.stressGroup.ResultSetID = mayexist.ResultSetID;
      }
    } else {
      this.stressGroup.Description = scenarioDetails.scenario_description;
      this.stressGroup.Mnemonic = scenarioDetails.mnemonic;
      this.stressGroup.ResultSetID = -1;
    }
    this.stressGroup.Scenario_ID = scenarioDetails.scenario_id;
    this.stressGroup.Scenario_Mnemonic = scenarioDetails.mnemonic;
    this.onChange();
  };

  public onDatasetSelect = event => {
    const selectElementValue = Number(event.target.value);
    const datasetDetails = this.simService.datasetMap.get(selectElementValue);
    const mayexist = this.simService.findResultsetItemInDB(
      this.parent.Scenario_ID,
      this.parent.DataSetID,
      this.stressGroup.Scenario_ID,
      datasetDetails.DataSetID
    );

    this.stressGroup.RunID = this.simService.getNewUUID();
    if (datasetDetails) {
      if (mayexist) {
        this.stressGroup.Mnemonic = mayexist.Mnemonic;
        if (mayexist.RunID) {
          this.stressGroup.RunID = mayexist.RunID;
        }
        if (mayexist.ResultSetID) {
          this.stressGroup.ResultSetID = mayexist.ResultSetID;
        }
      } else {
        this.stressGroup.ResultSetID = -1;
        this.stressGroup.Mnemonic = this.stressGroup.Scenario_Mnemonic;
      }
      this.stressGroup.DataSetID = datasetDetails ? datasetDetails.DataSetID : selectElementValue;
      this.stressGroup.DataSetName = datasetDetails ? datasetDetails.DataSetName : `*dataset no longer exists*`;
      this.onChange();
    }
    this.changeDatasetToggle();
  };

  public handleClickIfOneItem(event: Event, callback) {
    if (event.target['clicked']) {
      event.target['clicked'] = undefined;
      callback(event);
    } else {
      event.target['clicked'] = true;
    }
  }
}
